import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Callback } from 'lib/types'
import { Slice, CreateAccountPayload, FetchCustomerCartIdDeps } from './types'
import { HTTP_STATUS } from 'lib/core/resources/constants'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'customer/createAccount',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<CreateAccountPayload>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state, action?: PayloadAction<CreateAccountPayload | undefined>) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = action?.payload ?? initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function createAccount (payload: FetchCustomerCartIdDeps, callback?: Callback): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())

    try {
      const state = getState()
      const storeId = state.common.storeConfig.payload?.id as number
      const response = await magentoClient.getClient().customer.createAccount({
        payload: {
          ...payload,
          customer: {
            ...payload.customer,
            store_id: storeId
          }
        }
      })
      const { data, status } = response
      if (status === HTTP_STATUS.OK) {
        dispatch(success(data))
        callback?.onSuccess?.()
      } else {
        dispatch(failure(data))
        callback?.onFailure?.()
      }
      return response
    } catch (e) {
      dispatch(failure())
      callback?.onFailure?.({
        error: new Error(`[Create Account] ${e.message}`)
      })
    }
  }
}
